import { render } from "./Tag.vue?vue&type=template&id=29025056&scoped=true"
import script from "./Tag.vue?vue&type=script&lang=js"
export * from "./Tag.vue?vue&type=script&lang=js"

import "./Tag.vue?vue&type=style&index=0&id=29025056&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29025056"],['__file',"src/scripts/common/components/Tag.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "29025056"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('29025056', __exports__)) {
    api.reload('29025056', __exports__)
  }
  
  module.hot.accept("./Tag.vue?vue&type=template&id=29025056&scoped=true", () => {
    api.rerender('29025056', render)
  })

}


export default __exports__